import { render } from "./SponsorTile.vue?vue&type=template&id=ae569af6&scoped=true"
import script from "./SponsorTile.vue?vue&type=script&lang=js"
export * from "./SponsorTile.vue?vue&type=script&lang=js"

import "./SponsorTile.vue?vue&type=style&index=0&id=ae569af6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae569af6"]])

export default __exports__